import { axiosConfig } from '../api/axios-config.js'

// 裝置總覽
export const overview = {
  // 取得
  get: (token) => axiosConfig.get('/api/overview', token)
}
